var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscendingButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.6a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h6zM10.5.5a.92.92 0 0 1 .934.907V7.26l.945-1.003a.954.954 0 0 1 1.319-.056.89.89 0 0 1 .058 1.28l-2.567 2.72a.95.95 0 0 1-1.377.003l-2.567-2.72a.888.888 0 0 1 .058-1.28.952.952 0 0 1 1.319.056l.945 1V1.407A.92.92 0 0 1 10.501.5zM5 6.4a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h4zM3 3.2a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h2zM1 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm12.55 13c.249 0 .45.224.45.5 0 .268-.19.487-.429.5H.45c-.249 0-.45-.224-.45-.5 0-.268.19-.487.429-.5H13.55z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingButton);
export default __webpack_public_path__ + "static/media/ascending-button.becefe7fca32b856cb99ec29c7df0e7f.svg";
export { ForwardRef as ReactComponent };